"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
let PagingComponent = class PagingComponent {
    constructor() {
        this._currentPage = 0;
        this.firstPage = 0;
        this.lastPage = 0;
        this.pageChanged = new core_1.EventEmitter();
    }
    get pageNumber() {
        return this._currentPage;
    }
    set pageNumber(page) {
        let old = this._currentPage;
        this._currentPage = page;
        this.onGoToPage(page);
    }
    ngOnInit() {
        this._currentPage = Number(this.firstPage);
    }
    ngOnDestroy() {
    }
    onNextPage() {
        let page = this._currentPage + 1;
        if (page <= this.lastPage) {
            this._currentPage++;
            this.pageChanged.emit(this._currentPage);
        }
    }
    onPrevPage() {
        let page = this._currentPage - 1;
        if (page >= this.firstPage) {
            this._currentPage--;
            this.pageChanged.emit(this._currentPage);
        }
    }
    //TODO: reset to prev page if number is not in range
    onGoToPage(page) {
        if (page >= this.firstPage && page <= this.lastPage) {
            this._currentPage = page;
            this.pageChanged.emit(this._currentPage);
            return true;
        }
        return false;
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], PagingComponent.prototype, "firstPage", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], PagingComponent.prototype, "lastPage", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], PagingComponent.prototype, "pageChanged", void 0);
PagingComponent = __decorate([
    core_1.Component({
        selector: 'paging',
        templateUrl: './@inax/commonUi/src/paging/paging.component.html',
        styleUrls: ['./@inax/commonUi/src/paging/paging.component.css']
    }),
    __metadata("design:paramtypes", [])
], PagingComponent);
exports.PagingComponent = PagingComponent;
